__turbopack_context__.v({
  "actionRow": "ActionRow-module-scss-module__aug4Ha__actionRow",
  "center": "ActionRow-module-scss-module__aug4Ha__center",
  "end": "ActionRow-module-scss-module__aug4Ha__end",
  "nowrap": "ActionRow-module-scss-module__aug4Ha__nowrap",
  "start": "ActionRow-module-scss-module__aug4Ha__start",
  "wrap": "ActionRow-module-scss-module__aug4Ha__wrap",
});
